import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CrmAccessService } from '../components/crm-component-tabs/crm-access.service';

const CRM_FALLBACK = ['/dashboard', 'crm', 'crm-overview'] as const;

/**
 * Blocks CRM Leads list and lead details when the user lacks get-leads.
 */
export const crmLeadsGuard: CanActivateFn = () => {
  const access = inject(CrmAccessService);
  const router = inject(Router);
  access.refresh();
  if (access.canViewLeads()) {
    return true;
  }
  return router.createUrlTree([...CRM_FALLBACK]);
};

/**
 * Blocks CRM Opportunities list and opportunity details when the user lacks get-opportunities.
 */
export const crmOpportunitiesGuard: CanActivateFn = () => {
  const access = inject(CrmAccessService);
  const router = inject(Router);
  access.refresh();
  if (access.canViewOpportunities()) {
    return true;
  }
  return router.createUrlTree([...CRM_FALLBACK]);
};
